export default __webpack_public_path__ + "static/case_img1-be030b03f79c77a145859c6300f5c6ac.webp";